import { render, staticRenderFns } from "./Pre_footer.vue?vue&type=template&id=3418fb0a&scoped=true&"
import script from "./Pre_footer.vue?vue&type=script&lang=ts&"
export * from "./Pre_footer.vue?vue&type=script&lang=ts&"
import style0 from "./Pre_footer.vue?vue&type=style&index=0&id=3418fb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418fb0a",
  null
  
)

export default component.exports